import { createContext } from 'react';

export interface ListContextProps {
  /**
   * If `true`, the list item will have compact spacing.
   */
  compact?: boolean;
  /**
   * If `true`, the left and right padding is removed from list items.
   */
  disableGutters?: boolean;
}

export const ListContext = createContext<ListContextProps>({
  compact: false,
  disableGutters: false,
});
